import { connect } from "react-redux";
import ElementsMenu from "../components/ElementsMenu";
import { sceneSlice } from "../../store/sceneSlice";
import { sessionSlice } from "../../store/sessionSlice";

const mapStateToProps = (state) => {
  return {
    elements: state.scene.elements,
    isAdmin: state.session.userType === "admin",
    canGrabMultipleObjs: state.scene.canGrabMultipleObjs,
    sessionType: state.session.sessionType,
    pdb: state.scene.pdb,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (data) => {
      dispatch(sceneSlice.actions.emitElementSubmit(data));
    },
    onScale: (id, type) => {
      dispatch(sceneSlice.actions.emitScaleUpdate({ id, type }));
    },
    onMoleculeScale: (type) => {
      dispatch(sceneSlice.actions.emitMoleculeScaleUpdate({ type }));
    },
    onUpdateRates: (type) => {
      dispatch(sceneSlice.actions.emitUpdateRatesChange({ type }));
    },
    onTemperatureChange: (deltaT) => {
      dispatch(sceneSlice.actions.emitTemperatureChange({ deltaT }));
    },
    onTemperatureSet: (newT) => {
      dispatch(sceneSlice.actions.emitTemperatureSet({ newT }));
    },
    onSetAtomRadiusFactors: (applyVDW) => {
      dispatch(sceneSlice.actions.emitSetAtomRadiusFactors({ applyVDW }));
    },
    onSetAtomColors: (applyColor) => {
      dispatch(sceneSlice.actions.emitSetAtomColors({ applyColor }));
    },
    onSetStickRadius: (applyRadius) => {
      dispatch(sceneSlice.actions.emitSetStickRadius({ applyRadius }));
    },
    onSetSelection: (toSelect) => {
      dispatch(sceneSlice.actions.emitSetSelection({ toSelect }));
    },
    onToggleSim: () => {
      dispatch(sessionSlice.actions.emitToggleSim());
    },
    onWritePDB: () => {
      dispatch(sessionSlice.actions.emitWritePDB());
    },
    onStartSim: () => {
      dispatch(sessionSlice.actions.emitStartSim());
    },
    onStopSim: () => {
      dispatch(sessionSlice.actions.emitStopSim());
    },
    onMolRotationSetByValue: (newMolRotations) => {
      console.log("origin 1")
      dispatch(sessionSlice.actions.emitSetMolRotationByValue({ newMolRotations }));
    },
    onMolRotationChange: (newMolRotations) => {
      console.log("origin 1")
      dispatch(sessionSlice.actions.emitSetMolRotationChange({ newMolRotations }));
    },
    onDelete: (id, type) => {
      dispatch(sceneSlice.actions.emitElementDelete({ id }));
    },
    onRecenter: (id) => {
      dispatch(sceneSlice.actions.emitElementRecenter({ id }));
    },
    onToggleEnable: (id) => {
      dispatch(sceneSlice.actions.emitElementEnable({ id }));
    },
    onSlideSubmit: (data) => {
      dispatch(sceneSlice.actions.emitSlideUpdate(data));
    },
    onDisplayToast: (message) => {
      dispatch(sessionSlice.actions.displayToast({ message }));
    },
    onUpdateGrabbingMultipleObjs: (permission) => {
      dispatch(
        sceneSlice.actions.emitGrabbingMultipleObjs({
          canGrabMultipleObjs: permission,
        })
      );
    },
    onReset: () => {
      dispatch(sessionSlice.actions.emitResetScene());
    }
  };
};

export const ElementsMenuContainer = connect(mapStateToProps, mapDispatchToProps)(ElementsMenu);
